import { jsx as _jsx } from "react/jsx-runtime";
import BacteriaSVG from '@svgs/global/Bacteria.svg';
import ChickenSVG from '@svgs/global/Chicken.svg';
import CollapseCircleSVG from '@svgs/global/CollapseCircle.svg';
import CowSVG from '@svgs/global/Cow.svg';
import DogSVG from '@svgs/global/Dog.svg';
import ExpandCircleSVG from '@svgs/global/ExpandCircle.svg';
import GutSVG from '@svgs/global/Gut.svg';
import LeafSVG from '@svgs/global/Leaf.svg';
import LoggedInSVG from '@svgs/global/LoggedIn.svg';
import NoPipetSVG from '@svgs/global/NoPipet.svg';
import PawHeartSVG from '@svgs/global/PawHeart.svg';
import PharmacySVG from '@svgs/global/Pharmacy.svg';
import SweetPotatoSVG from '@svgs/global/SweetPotato.svg';
// RTB Icons, whose initial fill color comes from an embedded image
// in the svg, need to be force-updated (via the `key` prop) whenever
// `className` changes in order to re-run the in-svg <script> that
// transforms their color to their tailwind-defined text color.
// (ExpandCircleIcon, CollapseCircleIcon, and LoggedInIcon have similar
// custom scripted coloring because they each have more than one color
// that cannot be changed with tailwind alone.)
function DogIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(DogSVG, { className: className }, className);
}
function CowIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(CowSVG, { className: className }, className);
}
function ChickenIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(ChickenSVG, { className: className }, className);
}
function BacteriaIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(BacteriaSVG, { className: className }, className);
}
function PawHeartIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(PawHeartSVG, { className: className }, className);
}
function SweetPotatoIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(SweetPotatoSVG, { className: className }, className);
}
function GutIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(GutSVG, { className: className }, className);
}
function NoPipetIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(NoPipetSVG, { className: className }, className);
}
function PharmacyIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(PharmacySVG, { className: className }, className);
}
function LeafIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(LeafSVG, { className: className }, className);
}
function ExpandCircleIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(ExpandCircleSVG, { className: className }, className);
}
function CollapseCircleIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(CollapseCircleSVG, { className: className }, className);
}
function LoggedInIcon(_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b;
    return _jsx(LoggedInSVG, { className: className }, className);
}
export { ChickenIcon };
export { CowIcon };
export { DogIcon };
export { BacteriaIcon };
export { PawHeartIcon };
export { SweetPotatoIcon };
export { GutIcon };
export { NoPipetIcon };
export { PharmacyIcon };
export { LeafIcon };
export { ExpandCircleIcon };
export { CollapseCircleIcon };
export { LoggedInIcon };
export { default as ArrowLeftIcon } from '@svgs/global/ArrowLeft.svg';
export { default as ArrowRightIcon } from '@svgs/global/ArrowRight.svg';
export { default as ArrowOutwardIcon } from '@svgs/global/ArrowOutward.svg';
export { default as BottleIcon } from '@svgs/global/Bottle.svg';
export { default as NNBrandIcon } from '@svgs/global/NomNomLogo.svg';
export { default as BriefcaseIcon } from '@svgs/global/Briefcase.svg';
export { default as CalendarIcon } from '@svgs/global/Calendar.svg';
export { default as ChartIcon } from '@svgs/global/Chart.svg';
export { default as CheckIcon } from '@svgs/global/Check.svg';
export { default as CheckboxIcon } from '@svgs/global/Checkbox.svg';
export { default as CheckboxEmptyIcon } from '@svgs/global/CheckboxEmpty.svg';
export { default as ChevronDownIcon } from '@svgs/global/ChevronDown.svg';
export { default as ChevronLeftIcon } from '@svgs/global/ChevronLeft.svg';
export { default as ChevronRightIcon } from '@svgs/global/ChevronRight.svg';
export { default as CloseIcon } from '@svgs/global/Close.svg';
export { default as CoinsInHandIcon } from '@svgs/global/CoinsInHand.svg';
export { default as CollapseIcon } from '@svgs/global/Collapse.svg';
export { default as ComputerIcon } from '@svgs/global/Computer.svg';
export { default as ContactIcon } from '@svgs/global/Contact.svg';
export { default as DogIdealWeightIcon } from '@svgs/global/DogIdealWeight.svg';
export { default as DogUnderweightIcon } from '@svgs/global/DogUnderweight.svg';
export { default as DogOverweightIcon } from '@svgs/global/DogOverweight.svg';
export { default as DollarIcon } from '@svgs/global/Dollar.svg';
export { default as ExpandIcon } from '@svgs/global/Expand.svg';
export { default as ExternalLinkIcon } from '@svgs/global/ExternalLink.svg';
export { default as FacebookIcon } from '@svgs/global/social/Facebook.svg';
export { default as HandshakeIcon } from '@svgs/global/Handshake.svg';
export { default as HelpIcon } from '@svgs/global/Help.svg';
export { default as InstagramIcon } from '@svgs/global/social/Instagram.svg';
export { default as LoggedOutIcon } from '@svgs/global/LoggedOut.svg';
export { default as MapPinLogoIcon } from '@svgs/global/MapPinLogo.svg';
export { default as MapPinPawIcon } from '@svgs/global/MapPinPaw.svg';
export { default as MenuIcon } from '@svgs/global/Menu.svg';
export { default as CollapseSmallIcon } from '@svgs/global/CollapseSmall.svg';
export { default as NewProductBadgeIcon } from '@svgs/global/NewProductBadge.svg';
export { default as PalmTreeIcon } from '@svgs/global/PalmTree_bone.svg';
export { default as PercentageIcon } from '@svgs/global/Percentage.svg';
export { default as PlayButtonIcon } from '@svgs/funnel/PlayButton.svg';
export { default as ExpandSmallIcon } from '@svgs/global/ExpandSmall.svg';
export { default as QuestionMarkCircleIcon } from '@svgs/funnel/TooltipFunnelDefault.svg';
export { default as SearchIcon } from '@svgs/global/Search.svg';
export { default as TrustPilotIcon } from '@svgs/global/TrustPilot.svg';
export { default as XTwitterIcon } from '@svgs/global/social/XTwitter.svg';
export { default as YouTubeIcon } from '@svgs/global/social/YouTube.svg';
